<template>
  <div
    class="page-send-captcha-wrapper"
    :class="[veriTipText != '获取验证码' && 'disable-click']"
    @click="getCaptcha"
  >
    {{ veriTipText }}
  </div>
</template>
<script>
  import { GetVerificationCode } from '@/api/user'
  import { CHECK_MOBILE_PHONE } from '@/util/validate'
  export default {
    name: 'SendCaptcha',
    props: {
      phone: {
        type: [Number, String]
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        veriTipText: '获取验证码',
        timer: null
      }
    },
    methods: {
      getCaptcha() {
        if (this.phone === '') {
          this.$toast('请填写手机号')
          return false
        }
        if (!CHECK_MOBILE_PHONE(this.phone)) {
          this.$toast('请填写正确手机号')
          return false
        }

        if (this.veriTipText === '60s' || this.veriTipText === '获取验证码') {
          GetVerificationCode({ mobilePhone: this.phone })
            .then(() => {
              this.veriTipText = '60s'
              let num = 60
              this.timer = setInterval(() => {
                num--
                if (num > 0) {
                  this.veriTipText = num + 's'
                } else {
                  clearInterval(this.timer)
                  this.veriTipText = '获取验证码'
                  this.timer = null
                }
              }, 1000)
            })
            .catch(e => {
              this.veriTipText = '获取验证码'
              this.$notify({ type: 'danger', message: e.message })
            })
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .page-send-captcha-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    line-height: 30px;
    width: 80px;
    border-radius: 15px;
    color: #3a81e8;
    font-size: 14px;
    box-sizing: border-box;
    padding: 0;
  }
  .disable-click {
    pointer-events: none;
    color: #a1c7ff !important;
  }
</style>
